import { ContentNugget, PanelNugget } from '@backrs_ui/common-ui';

import { nuggetMapper } from '@backrs_ui/grow-ui/src/components/Nuggets/nugget.util';
import { LubavInternship } from '@backrs_ui/grow-ui/src/models/models';
import { setCurrentDialogNugget } from '@backrs_ui/grow-ui/src/redux/contentNugget/contentNugget';
import { useAppDispatch } from '@backrs_ui/grow-ui/src/redux/hooks';

type InternshipNuggetProps = Readonly<{
  internship: LubavInternship;
}>;

export const InternshipNugget = ({ internship }: InternshipNuggetProps) => {
  const dispatch = useAppDispatch();

  const internshipNugget: ContentNugget = {
    id: Number(internship.metadata.id),
    title: internship.metadata.role_title,
    description: internship.metadata.ai_description,
    slug: internship.metadata.id.toString(),
    star_rating: 0,
    value_rating: 0,
    variant: 'internship',
    is_browsable: false,
    internship_info: internship.metadata,
    content_nugget_theme: 'Internship',
  };

  return (
    <PanelNugget
      key={internship.metadata.id}
      title={internship.metadata.role_title}
      subTitle={internship.metadata.company}
      subText={internship.relevance}
      size="SMALL"
      onClick={() => {
        dispatch(setCurrentDialogNugget(internshipNugget));
      }}
      variant={nuggetMapper({ nugget: internshipNugget })}
    />
  );
};
